import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Title = styled.p`
  color: var(--text-default);
  margin: 0 0 56px 0;
  ${typographyV2.titleLg};
`;

export const KeyMetricsWrapper = styled.div`
  margin-top: 24px;
  margin-bottom: 16px;
`;
